export default {
  getQuestionsList: state => state.questionsList,
  hasQuestionsToList: state => Boolean(state?.questionsList?.length),
  getSavedQuestionsUuid: state => state.savedQuestionsUuid
}
